export function getUnhandledRejectionEventHandler(logError: (error: Error) => void) {
  return (evt: PromiseRejectionEvent) => {
    evt?.preventDefault()
    if (evt instanceof CustomEvent && evt.type === 'unhandledrejection') {
      return
    }
    if (!evt?.reason || !(evt?.reason instanceof Error)) {
      return
    }
    logError(evt.reason)
  }
}
